// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './utils/request.js'
import "../node_modules/swiper/css/swiper.min.css";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/index.js'
import './utils/directive'
import '@/assets/fonts/font.css'
import Popup from  '@/components/TranslationBulletIelts/index.vue'

Vue.config.productionTip = false
Vue.component('Popup', Popup);
Vue.directive('drag', (el) => {
  const oDiv = el // 当前元素
  const minTop = oDiv.getAttribute('drag-min-top')
  const ifMoveSizeArea = 20
  oDiv.onmousedown = e => {
    let target = oDiv
    while (window.getComputedStyle(target).position !== 'absolute' && target !== document.body) {
      target = target.parentElement
    }

    document.onselectstart = () => {
      return false
    }
    if (!target.getAttribute('init_x')) {
      target.setAttribute('init_x', target.offsetLeft)
      target.setAttribute('init_y', target.offsetTop)
    }

    const initX = parseInt(target.getAttribute('init_x'))
    const initY = parseInt(target.getAttribute('init_y'))

    // 鼠标按下，计算当前元素距离可视区的距离
    const disX = e.clientX - target.offsetLeft
    const disY = e.clientY - target.offsetTop
    const Owidth = innerWidth;
    const Ohight = innerHeight;

    document.onmousemove = e => {
      // 通过事件委托，计算移动的距离
      // 因为浏览器里并不能直接取到并且使用clientX、clientY,所以使用事件委托在内部做完赋值
      let left = e.clientX - disX
      let top = e.clientY - disY
          // 限制拖拽范围不超出可视区
          if ( left <= 0) {
            left = 5    // 设置成5,离边缘不要太近
          } else if (left > document.documentElement.clientWidth - target.clientWidth) { // document.documentElement.clientWidth屏幕可视区宽度
             left = document.documentElement.clientWidth - target.clientWidth - 5
          }

         if ( top <= 0) {
            top = 5
          } else if (top > document.documentElement.clientHeight - target.clientHeight) {
             top = document.documentElement.clientHeight - target.clientHeight - 5
          }
          target.style.left = left + 'px'
          target.style.top= top + 'px'

      // const r = (e.clientX - disX) + 450 + minTop*1
      // const b = (e.clientY - disY) + 350 + minTop*1
      // 计算移动当前元素的位置，并且给该元素样式中的left和top值赋值
      // target.style.top = (t < minTop ? minTop : t) + 'px'
      // target.style.left = (l < minTop ? minTop : l) + 'px'
      // target.style.right = (r < 0 ? 0 : r) + 'px'
      // target.style.bottom = (l < 50 ? 50 : l) + 'px'

      if (Math.abs(left - initX) > ifMoveSizeArea || Math.abs(top - initY) > ifMoveSizeArea) {
        target.setAttribute('dragged', '')
      } else {
        target.removeAttribute('dragged')
      }
    }
    document.onmouseup = e => {
      document.onmousemove = null
      document.onmouseup = null
      document.onselectstart = null
    }
    // return false不加的话可能导致黏连，拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
    return false
  }
})

Vue.directive('drag-height', {
  bind(el, binding, vnode) {
    let startY;
    let initialHeight;
    let targetElement = document.getElementById(binding.value.targetId);

    el.onmousedown = function (e) {
      startY = e.clientY;
      console.log(targetElement, 'targetElement');
      initialHeight = targetElement.clientHeight;
      document.onmousemove = mouseMoveHandler;
      document.onmouseup = mouseUpHandler;
      return false; // prevent default action and stop event propagation
    };

    function mouseMoveHandler(e) {
      let endY = e.clientY;
      let moveLen = initialHeight + (endY - startY);

      if (moveLen < 200) moveLen = 200;
      if (moveLen > 500) moveLen = 500;

      requestAnimationFrame(() => {
        targetElement.style.height = moveLen + "px";
      });
    }

    function mouseUpHandler(e) {
      document.onmousemove = null;
      document.onmouseup = null;
    }
  }
});


Vue.prototype.$axios=axios
Vue.use(ElementUI)
let vueThis=new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})

export default vueThis



// WEBPACK FOOTER //
// ./src/main.js